// extracted by mini-css-extract-plugin
module.exports = {"amount":"BalanceDue_amount__2NTfq","list":"BalanceDue_list__3n92M","listRow":"BalanceDue_listRow__1mst3","total":"BalanceDue_total__17dF-"};